import Cookies from "js-cookie";
import { deleteCookie, setCookie } from "cookies-next";
import { SECURE_COOKIE_OPTIONS } from "@/utils/cookies/cookieOptions";

// Everything writes the cookie at "/" except the cart's getServerSideProps,
// which sends `Set-Cookie` with no Path — so on /en/cart the browser files a
// second copy under "/en". A delete scoped to "/" cannot touch that one, which
// is how a previous account's cart id survives logout. Clear both.
const QUOTE_COOKIE_PATHS = ["/", "/en"];

const clearQuoteCookie = () => {
  for (const path of QUOTE_COOKIE_PATHS) {
    Cookies.remove("quote", { path });
    deleteCookie("quote", { path });
  }
};

/**
 * Safe setter for quote cookie that removes both old versions before setting new one
 * This ensures no duplicate quote cookies exist when both js-cookie and cookies-next are used
 * @param {string} value - The cart_id or quote value to set
 */
export const setQuoteCookie = (value) => {
  // Remove old quote from both libraries to prevent duplicates
  clearQuoteCookie();
  // Set new quote using cookies-next
  setCookie("quote", value, SECURE_COOKIE_OPTIONS);
};

/**
 * Safe remover for quote cookie that removes from both libraries
 */
export const removeQuoteCookie = () => {
  clearQuoteCookie();
};
